import LayoutConstraintsUtil from './LayoutConstraintsUtil';
import editorConstraints from './editorConstraintsRegistry';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
export default class EditorLayoutConstraintsUtil extends LayoutConstraintsUtil {
  constructor(editorAPI: EditorAPI, compPointer: CompRef) {
    super(editorAPI, compPointer, editorConstraints);
  }
}
